export function convertDateUtc(date) {
  const inputDate = new Date(date);

  if (!isNaN(inputDate) && date !== null && date !== undefined && date !== "") {
    return inputDate.toISOString();
  } else {
    return "";
  }
}
